import { render, staticRenderFns } from "./subEdit.vue?vue&type=template&id=1d64fd52&scoped=true&"
import script from "./subEdit.vue?vue&type=script&lang=js&"
export * from "./subEdit.vue?vue&type=script&lang=js&"
import style0 from "./subEdit.vue?vue&type=style&index=0&id=1d64fd52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64fd52",
  null
  
)

export default component.exports